import qs from 'qs'

import {monolithGet, monolithPost} from './fetch'
import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'

export const getOrders = (orderId) =>
  monolithGet(`/transactioncomposite/orders/${orderId}`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )

export const getOrderItemsToExchange = (orderId) =>
  monolithGet(
    `/v1/orders/${orderId}/items${qs.stringify(
      {
        'single-products': 'True',
      },
      {
        addQueryPrefix: true,
      },
    )}`,
  ).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )

export const submitExchangeRequest = (orderId, payload) =>
  monolithPost(`/v1/orders/${orderId}/exchanges_with_fallback`, payload)

export const getAllUserOrders = (userId) =>
  monolithGet(`/v1/users/${userId}/orders`).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
